import { render, staticRenderFns } from "./SpinnerCentre.vue?vue&type=template&id=213e9b6c&"
import script from "./SpinnerCentre.vue?vue&type=script&lang=js&"
export * from "./SpinnerCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports